import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import Global = WebAssembly.Global;
import {GlobalObjectService} from '../../../../class/global-obj';
import {HttpFormDataService} from '../../../../services/services';
import {FormEventService} from '../../../../services/formEventService';
import {IHttpSetting} from '../../../../interface/dataset-params';


@Component({
    selector: 'noos-bomproductfield',
    templateUrl: './bomproductfield.component.html',
    styleUrls: ['./bomproductfield.component.scss']
})

@NoosFormTypeService.register('bomproductfield')
export class BomproductfieldComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;
    thisAppearance: any = 'outline';

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    productId = 0;
    setting: IHttpSetting;

    constructor(private httpService: HttpFormDataService) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {
        if (this.isFilter) {
            this.prop.requared = false;
        }

        const outData = GlobalObjectService.getVar('outData_' + this.formId.toString());
        console.log('outData:', outData, this.formId,'...',outData.form_data,'---');
        if (outData) {
            this.productId = outData.product_id || 0;
            if (outData && outData.form_data !== null && outData.form_data !== undefined && outData.form_data.length>0) {
                const findMe = outData.form_data.filter(ff => ff.name === this.prop.name);
                if (findMe.length > 0) {
                    this.prop.defaultValue = findMe[0].value;
                }
            }
            if (this.productId > 0 && this.prop.options.bom_field !== undefined && this.prop.defaultValue === '') {
                this.httpService.bomProductVaraible(this.setting, this.productId, this.prop.options.bom_field).subscribe(ret => {
                    if (ret.complete) {
                        this.prop.defaultValue = ret.data;
                    }
                });
            }
        }

    }


    onKeydown($event: any) {
        this.keyOnEnter.emit();
    }

}
